import IconGoogleTranslate from 'approot/shared/icons/icon-google-translate';
import * as Styled from './activity-present-attribution.style';

const ActivityPresentAttribution = () => (
  <Styled.Attribution aria-label="Translated by Google">
    <IconGoogleTranslate width={122} height={16} />
  </Styled.Attribution>
);

export default ActivityPresentAttribution;
